export function gridColumnSum(values, col) {
	let sum = 0;
	values.forEach((value) => {
		sum += value[col] * 1
	})
	return sum;
}

export function gridColumnAvg(values, col) {
	let sum = 0;
	let i = 0;
	values.forEach((value) => {
		i++;
		sum += value[col] * 1
	})
	return sum / i;
}

export function getWeekendName(value) {
	switch (value) {
		case "0":
			return "일"
		case "1":
			return "월"
		case "2":
			return "화"
		case "3":
			return "수"
		case "4":
			return "목"
		case "5":
			return "금"
		case "6":
			return "토"
	}
}

export function lpad(str, padLen, padStr) {
	if (padStr.length > padLen) {
		console.log("오류 : 채우고자 하는 문자열이 요청 길이보다 큽니다");
		return str;
	}
	str += ""; // 문자로
	padStr += ""; // 문자로
	while (str.length < padLen)
		str = padStr + str;
	str = str.length >= padLen ? str.substring(0, padLen) : str;
	return str;
}

export function getErestErpCode(cornerCd) {
	switch (cornerCd) {
		case "0002":  // 자율식당
		case "0043":
			return "001";
		case "0001":  // 편의점
			return "002";
		case "0076":
			return "003";
		case "0078":
		case "0079":
			return "004";
		case "0004":
		case "0097":
			return "005";
		case "0008":
			return "006";
		case "0010":
			return "007";
		case "0007":
			return "008";
		case "0087":
			return "009";
		case "0028":
			return "010";
		case "0055":
			return "011";
		case "0086":
			return "012";
		case "0073":
			return "013";
		case "0084":
			return "014";
		case "0077":
			return "015";
		case "0085":
			return "016";
		case "0083":
			return "017";
		case "0048":
			return "018";
		case "0074":
			return "019";
		case "0075":
			return "020";
		case "0096":
			return "021";
		case "0102":
			return "022";
		case "0104":
			return "023";
		case "0105":
			return "024";
		// case "0075":
		//   return "025";
	}
}
